// import { connectRouter } from 'connected-react-router'
// import { createBrowserHistory } from 'history'
import actsReducer from './acts/reducer';
import authReducer from './auth/reducer';
import financesReducer from './finances/reducer';
import headerReducer from './header/reducer';
import officeTripReducer from './officeTrip/reducer';
import tripsReducer from './trips/reducer';
// export const history = createBrowserHistory()
export const rootReducer = {
    auth: authReducer,
    acts: actsReducer,
    header: headerReducer,
    trips: tripsReducer,
    officeTrip: officeTripReducer,
    finances: financesReducer
};
